import { Id } from "PFTypes";

export enum ReassignSelectOption {
  ThisBooking = "ThisBooking",
  AllBookings = "AllBookings",
  ThisAndFuture = "ThisAndFuture"
}

export type CurrentBooking = {
  id: Id;
  startDate: string;
  endDate: string;
};
